import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TagBox } from "devextreme-react/tag-box";
import { DateBox } from "devextreme-react/date-box";
import { Validator, RequiredRule } from "devextreme-react/validator";
import { Button } from "devextreme-react/button";
import { useAgents } from "../../context/AgentContext";
import { useStatuses } from "../../context/StatusContext";

const OverseasReport = ({_reportTitle}) => {
  const navigate = useNavigate();
  const agents = useAgents() || [];
  const statuses = useStatuses() || [];

  // State for inputs
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [reportTitle, setReportTitle] = useState([_reportTitle]);
  
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate inputs
    if (!startDate) return alert("Start Date is required");
    if (!endDate) return alert("End Date is required");
    if (!selectedStatuses.length) return alert("At least one status must be selected");
    if (!selectedAgents.length) return alert("At least one agent must be selected");

        
    try {
      navigate("/reports/ethiopianOverseas", { state: { startDate: startDate,  endDate: endDate, selectedStatuses: selectedStatuses, selectedAgents: selectedAgents, reportTitle: _reportTitle} });
    } catch (error) {
      console.error("❌ Error fetching report:", error.message);
    }
  };

  return (
    <div className="container mt-4" style={{ maxWidth: "500px" }}>
      <h5 className="es-label-title">{_reportTitle}</h5>
      <div className="card p-3">
        <form onSubmit={handleSubmit}>
          {/* Start Date */}
          <div>
            <label className="es-field-label">Start Date:</label>
            <DateBox
              displayFormat="yyyy-MM-dd"
              placeholder="Select Start Date"
              onValueChanged={(e) => setStartDate(e.value)}
            >
              <Validator>
                <RequiredRule message="Start Date is required" />
              </Validator>
            </DateBox>
          </div>

          {/* End Date */}
          <div>
            <label>End Date:</label>
            <DateBox
              displayFormat="yyyy-MM-dd"
              placeholder="Select End Date"
              onValueChanged={(e) => setEndDate(e.value)}
            >
              <Validator>
                <RequiredRule message="End Date is required" />
              </Validator>
            </DateBox>
          </div>

          {/* Status Dropdown */}
          <div>
            <label>Status:</label>
            <TagBox
              dataSource={statuses}
              showSelectionControls={true}
              applyValueMode="instantly"
              placeholder="Select Status"
              searchEnabled
              multiline={false}
              showDropDownButton={true}
              onValueChanged={(e) => setSelectedStatuses(e.value)}
            />
          </div>

          {/* Agent Dropdown */}
          <div>
            <label>Agent:</label>
            <TagBox
              dataSource={agents}
              displayExpr="companyName"
              valueExpr="companyID"
              showSelectionControls={true}
              applyValueMode="instantly"
              placeholder="Select Agent"
              searchEnabled
              multiline={false}
              showDropDownButton={true}
              onValueChanged={(e) => setSelectedAgents(e.value)}
            />
          </div>

          <br />
          {/* Submit Button */}
          <Button text="Generate Report" type="success" useSubmitBehavior={true} />
        </form>
      </div>
    </div>
  );
};

export default OverseasReport;